import { render, staticRenderFns } from "./BuyMeACoffee.vue?vue&type=template&id=babcc7e4&scoped=true&"
import script from "./BuyMeACoffee.vue?vue&type=script&lang=js&"
export * from "./BuyMeACoffee.vue?vue&type=script&lang=js&"
import style0 from "./BuyMeACoffee.vue?vue&type=style&index=0&id=babcc7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babcc7e4",
  null
  
)

export default component.exports